export const PROJECT_NAME = 'Kernel';
export const SHORT_PROJECT_NAME = 'Kernel';

export default { PROJECT_NAME, SHORT_PROJECT_NAME };
